<template>

    <div>

        <div v-for="upload in selectedAttachments">

            <div class="row">

                <div class="col">
                    <!-- will always be selected in this list-->
                    <upload-component :key="upload.fileName"
                                      :pre-populate-selected-file="upload"
                                      :attachment-group-id="attachmentGroupId"
                                      :accepted-types="acceptedTypes"
                                      :is-temp-upload="isTempUpload"
                                      @file-was-removed="fileRemoved"
                                      @is-doing-operation="isDoingOperation">
                    </upload-component>
                </div>
            </div>

        </div>

        <div v-if="selectedAttachments.length < maxNumberOfUploads" class="row mt-2">

            <div class="col">
                <!-- will always be a "new" to upload -->
                <upload-component :key="'add-upload-' + currentNewItemIndex"
                                  :attachment-group-id="attachmentGroupId"
                                  :accepted-types="acceptedTypes"
                                  :is-temp-upload="isTempUpload"
                                  @file-was-selected="fileSelected"
                                  @file-was-removed="fileRemoved"
                                  @is-doing-operation="isDoingOperation">
                    <template v-slot:add-attachment-row-content="props">
                        <div class="col">
                            <a href="#" @click.prevent="props.addattachment"><i class="fas fa-paperclip mr-2" aria-label="Add attachments"></i>{{ contentBlocks.addAttachments }} </a>
                        </div>
                        <div class="cant-attach-helper col text-right">
                            <a data-toggle="collapse" href="#cant-attach-helper" role="button" aria-expanded="false" aria-controls="cant-attach-helper">{{ contentBlocks.cantAttach }}</a>
                        </div>
                    </template>

                </upload-component>
            </div>
        </div>

        <div id="cant-attach-helper" class="collapse mt-2">
            <div class="row">
                <div class="col">
                    {{ contentBlocks.types }}
                </div>
                <div class="col-auto">
                    <a data-toggle="collapse" href="#cant-attach-helper" class="close text-white btn-circle close-filter-dialog-button close-dialog-icon c-pointer m-0 p-0" aria-label="Close" aria-expanded="false" aria-controls="cant-attach-helper">
                        <span aria-hidden="true">×</span>
                    </a>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    doc, docx, pages, wps, bmp, gif, jpg, png, tif, tiff, pct, pcf, xlr, xls, xlxs, cab, pdf, txt, csv
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <slot name="multiple-error-slot"></slot>
            </div>
        </div>

        <i class="fs-13">       
            <p v-html="contentBlocks.attach"></p>
        </i>
            
        <!--<hr />

        <div class="tips-for-taking-pics-helper row mt-2" v-if="isTipsForTakingPicsVisible">
            <div class="col">
                <a href="https://www.mskcc.org/cancer-care/patient-education/tips-taking-pictures-share-your-healthcare-provider" target="_blank">Tips for Taking Pictures to Share with Your Healthcare Provider</a>
            </div>
        </div>-->

</div>

</template>

<style>
    .close-filter-dialog-button {
        background-color: #1c75cd !important;
        opacity: 1 !important;
    }
</style>

<script>

    import uploadComponent from './file.uploader.vue';
    import jlinq from '@SharedServices/linq.javascript.service';
    import { MessageHttpSvc } from '@SharedHttpServices/message.httpservice';

    export default {
        name: 'fileUploadMultiple',
        props: {
            attachmentGroupId: { type: String },
            acceptedTypes: { type: String, default: '.doc,.docx,.bmp,.jpg,.jpeg,.xls,.xlsx,.png,.tif,.tiff,.txt,.pdf,.csv,image/*' }, //filter for the upload screen that defaults the filter to
            isTempUpload: { type: Boolean, default: false }, //is this a temporary upload ie: financial forms - upload then render to pdf and will never be sent in a psm
            isTipsForTakingPicsVisible: { type: Boolean, default: true }
        },
        components: {
            'upload-component': uploadComponent
        },
        data: function () {
            return {
                maxNumberOfUploads: 5,
                selectedAttachments: [],
                currentNewItemIndex: 0,
                contentBlocks: {}
            }
        },
        methods: {

            isDoingOperation(isExecuting) {
                this.$emit('is-doing-operation', isExecuting);
            },

            fileSelected: function (fileInfo) {
                this.selectedAttachments.push(fileInfo);
                this.currentNewItemIndex++;
                this.$emit('file-is-selected', fileInfo);
            },

            fileRemoved: function (fileInfo, key) {
                this.selectedAttachments = this.selectedAttachments.Where(x => x.fileName != fileInfo.fileName).ToArray();
                this.$emit('file-is-removed', fileInfo);
            }

        },
        created: function(){
            MessageHttpSvc.GetContent()
                .done(res => {
                    this.contentBlocks = res;
                });
        }
    };
</script>

